export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_03.20d4f080.jpg";